import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './Notification.css';
import { getTimeDiffRepresentation } from '../../util/time';
import { useCustomNotificationContext } from './context';
import classNames from 'classnames';
import { updateUserNotificationsInteraction } from '../../util/api';
import {
    CUSTOM_EVENT_UI_TIRE,
    CUSTOM_USER_NOTIFICATION_EVENTS_CONFIG,
    NOTIFICATION_FEED_URL_STATE_KEY,
    NOTIFICATION_FEED_URL_STATE_NAVIGATED_FROM,
} from '../../customUserNotificationEvents-config';

const { REACT_APP_CANONICAL_ROOT_URL: ROOT_URL } = process.env;

export default ({ notification }) => {
    const {
        checkIfNotificationIsNew,
        setOpen,
        markNotificationsAsViewed,
    } = useCustomNotificationContext();
    const { logo, description, createdAt, id, eventName, sidenote, isExternal } = notification;
    const history = useHistory();
    const getNotificationLink =
        CUSTOM_USER_NOTIFICATION_EVENTS_CONFIG[eventName]?.getNotificationLink;
    const link = getNotificationLink?.(notification || {}) || notification.link || ROOT_URL;

    const today = new Date();
    const isNewItem = checkIfNotificationIsNew(notification);

    const { hours, days, minutes } = getTimeDiffRepresentation(new Date(createdAt), today, {
        prefix: 'Vor',
        daysLongText: 'Tagen',
    });

    const handleNotificationClick = async () => {
        if (!eventName) {
            /**
             * if there is no eventName, consider it to be a DB item
             */
            await updateUserNotificationsInteraction(id);
        }
        // a link is local if it is either relative (e.g. /flip-and-win) or absolute within ROOT_URL
        const isRelativeLink = link?.startsWith('/') && !link.startsWith('//');
        const isLocalNavigation = isRelativeLink || (!!ROOT_URL && link?.includes(ROOT_URL));

        await markNotificationsAsViewed(notification);

        setOpen(false);

        if (isLocalNavigation) {
            const pathFromLink = isRelativeLink ? link : link.replace(ROOT_URL, '');
            const baseUrl = new URL(pathFromLink, ROOT_URL || window.location.origin);
            baseUrl.searchParams.set(
                NOTIFICATION_FEED_URL_STATE_KEY,
                NOTIFICATION_FEED_URL_STATE_NAVIGATED_FROM
            );

            return history.push({
                pathname: baseUrl.pathname,
                search: baseUrl.search,
                state: { from: history?.location?.pathname, event: CUSTOM_EVENT_UI_TIRE },
            });
        }
        if (isExternal) {
            return window.open(link, '_blank');
        }

        window.location.replace(link);
    };

    return (
        <div className={css.root} onClick={handleNotificationClick}>
            <div className={css.logoHolder} style={{ backgroundImage: `url(${logo})` }} />
            <aside className={css.asideSection}>
                <p
                    className={classNames(css.notificationDescription, {
                        [css.isNewItem]: isNewItem,
                    })}
                >
                    <span>{description}</span>{' '}
                    {sidenote && <span className={css.sidenote}>{sidenote}</span>}
                </p>
                <div className={css.timestamp}>
                    {isNewItem && <div className={css.badge}>Neu</div>}
                    <p className={css.lastTransitionedAt}>{days || hours || minutes || ''}</p>
                </div>
            </aside>
        </div>
    );
};
